import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { TariffPollDialogProps } from './TariffPollDialog.types';

export const TARIFF_POLL_MODAL_ID = 'tariff-poll-modal';

export const renderTariffPollModal = (data?: TariffPollDialogProps) => openPopupHelper({ popupName: popupNames.TARIFF_POLL_MODAL, data });
